import { z } from 'zod'

export const userUpdateSchema = z.object({
    firstName: z.string().max(150, 'Maximálně 150 znaků'),
    lastName: z.string().max(150, 'Maximálně 150 znaků'),
    email: z.string().email('Neplatný e-mail').min(1, 'Povinné pole'),
    validUntil: z.string().nullable(),
    isActive: z.boolean(),
    isSuperuser: z.boolean()
})

export type UserUpdateValues = z.infer<typeof userUpdateSchema>
